<template>
  <div style="margin-top: 5em">
    <h2 class="text-muted text-center pb-4">custom instruments</h2>
    <div class="container text-center mb-5 w-75">
      <img src="@/assets/img/lathe.jpg" style="width: 50%" class="pb-5" />
      <p>
        Every instrument I make can be built to your specifications — whether
        it's an <b>Irish flute</b>, a <b>headjoint</b> for your Boehm flute, or
        a <b>whistle</b>.
        <LinkComponent href="/#contact" link-text="Contact me" />
        to talk it through.
      </p>
      <p>
        Available materials range from different hardwoods to aluminium and
        brass. There are technical restrictions regarding bore, wall thickness,
        the combination of materials and so on — I'm happy to consult with you
        to arrive at something that plays and works well.
      </p>
      <p>
        Tell me what you have in mind: the sound you're after, your budget, and
        any preferences on material, tuning or keys.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LinkComponent from "@/components/util/LinkComponent.vue";

export default defineComponent({
  name: "CustomView",
  components: { LinkComponent },
});
</script>

<style src="@/assets/css/style.css"></style>
